import { Injectable, signal, WritableSignal } from "@angular/core";
import { toObservable } from "@angular/core/rxjs-interop";
import { Observable } from "rxjs";
import { updateStatus, updateStatusDetail } from "./data_store/status-store";

@Injectable({ providedIn: "root" })
export class AppStore {
  private readonly _ctTypes: WritableSignal<any[]> = signal<any[]>([]);
  private readonly _statusStore: WritableSignal<any[]> = signal<any[]>([]);

  // read adapters (created in root injection context)
  readonly ctTypes$: Observable<any[]> = toObservable(this._ctTypes);
  readonly statusStore$: Observable<any[]> = toObservable(this._statusStore);

  // direct signal reads (future template use)
  readonly ctTypes = this._ctTypes.asReadonly();
  readonly statusStore = this._statusStore.asReadonly();

  // ctTypes mutations
  setTypes(payload: any[]): void {
    this._ctTypes.set([...payload]);
  }

  updateType(payload: any): void {
    this._ctTypes.update((s) =>
      s.map((i) => (i.code === payload.code ? { ...i, ...payload } : i))
    );
  }

  // statusStore mutations
  setStatus(payload: any[]): void {
    this._statusStore.set([...payload]);
  }

  updateStatus(payload: any): void {
    this._statusStore.update((s) => updateStatus(s, { payload }));
  }

  updateStatusDetail(payload: any): void {
    this._statusStore.update((s) => updateStatusDetail(s, { payload }));
  }

  activeStatus(): void {
    this._statusStore.update((s) => s.map((i) => ({ ...i, show: true })));
  }

  activeStatusDetail(): void {
    this._statusStore.update((s) => s.map((i) => ({ ...i, showDetail: true })));
  }

  inactiveStatus(): void {
    this._statusStore.update((s) => s.map((i) => ({ ...i, show: false })));
  }

  inactiveStatusDetail(): void {
    this._statusStore.update((s) =>
      s.map((i) => ({ ...i, showDetail: false }))
    );
  }

  clear(): void {
    this._ctTypes.set([]);
    this._statusStore.set([]);
  }
}
